import React, { useState, useEffect } from 'react';
import { Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import { routersConfig } from './router/routersConfig';
import Home from './pages/home/Home';
import SplashScreen from './components/splashScreen/SplashScreen';
import NavBar from './components/navbar/Navbar';
import OfflineHandler from './components/offline/OfflineHandler.jsx';
import useNetworkStatus from './hook/useNetworkStatus'; // Import custom hook
import Joyride from 'react-joyride';
import Footer from './components/footer/Footer.jsx';
import { getJoyrideSteps } from './utils/joyrideSteps.js';
import Callback from './pages/callback/Callback';
import { getLoginUrl } from './utils/Constant';
import ProtectedRoute from './components/ProtectedRoute/index.jsx';

const App = () => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const isOnline = useNetworkStatus();
  const location = useLocation();
  const navigate = useNavigate();
    const checkTokenAndNavigate = () => {
      const path = window.location.pathname;
      if (path === '/callback' || path === '/clear-session') return;
      const token = localStorage.getItem('accessToken') || localStorage.getItem('token');
      if (!token) {
        setIsLoggedIn(false);
        window.location.href = getLoginUrl();
      } else {
        setIsLoggedIn(true);
      }
    };
    useEffect(() => {
    checkTokenAndNavigate();
  }, [location.pathname]);
    useEffect(() => {
    if (location.pathname === '/clear-session') {
      localStorage.clear();
    }
  }, [location.pathname]);
  const isCallbackPage = location.pathname === '/callback';
  const [run, setRun] = useState(false);
  const [stepIndex, setStepIndex] = useState(0);
  const [steps, setSteps] = useState([]);
  const [username, setUsername] = useState('');
  const [arearange, setarearange] = useState('');

  const [pageVisible, setPageVisible] = useState(false);
  useEffect(() => {
    setPageVisible(false);
    const id = requestAnimationFrame(() => setPageVisible(true));
    return () => cancelAnimationFrame(id);
  }, [location.pathname]);

  useEffect(() => {
    const userData = JSON.parse(localStorage.getItem('userData'));
    const name = userData?.employeeName || '';
    const areaRange= userData?.areaRange||'';
    setarearange(areaRange);
    setUsername(name);
  }, [location.pathname]);

  useEffect(() => {
    if (username && arearange)
    {
      setSteps(getJoyrideSteps(username,arearange));
    }
  }, [username,arearange]);





  return isOnline ? (
    <div className="flex h-screen">
      <Joyride
        steps={steps}
        run={run}
        stepIndex={stepIndex}
        continuous
        showSkipButton
        showBackButton
        hideCloseButton
        disableBeacon={true}
        spotlightPadding={1}
        scrollToFirstStep
        disableOverlayClose
        disableScrolling={false}
        scrollOffset={60}

        styles={{
          options: {
            width: window.innerWidth < 640 ? 240 : 300,
            zIndex: 10000,
            borderRadius:'8px',

          },
          buttonSkip:{
          color:'#A04D95',
          fontWeight:'600',
          fontSize:'14px'
          },
          tooltip:{
          fontSize:'14px',
          marginRight: window.innerWidth < 640 ? '20px' :'20px',
          },
          buttonNext:{
            backgroundColor:'#A04D95',
            fontWeight:'600',
            borderRadius:'7px',
            color:'white',
            fontSize:'14px'

          },
          buttonBack:{
            backgroundColor:'#A04D95',
            fontWeight:'600',
            borderRadius:'7px',
            color:'white',
            fontSize:'14px'
          },
        }}
      callback={(data) => {
        const { type, index, status, action } = data;

        if (status === 'finished' || status === 'skipped') {
          setRun(false);
          setStepIndex(0);
          setIsDrawerOpen(false);
        } else if (type === 'step:after') {
          if (action === 'next') {
            setStepIndex(index + 1);
          } else if (action === 'prev') {
            setStepIndex(index - 1);
          }
        } else if (type === 'step:before') {
          setStepIndex(index);
        }
    }}
    />

    {/* Navbar */}
      {!isCallbackPage && (
      <NavBar
        isLoggedIn={isLoggedIn}
        isDrawerOpen={isDrawerOpen}
        toggleDrawer={() => setIsDrawerOpen
        (prev => !prev)}
        startTour={() => {
          setStepIndex(0);
          setRun(true);
        }}
      />
      )}




    {/* Main Content */}
    <main
      className={`flex-1 overflow-y-auto transition-opacity duration-300 ${pageVisible ? 'opacity-100' : 'opacity-0'} ${isLoggedIn && location.pathname === '/home' ? 'pt-14' : ''}`}
    >
      <Routes>
        <Route path="/" element={<SplashScreen />} />
        <Route path="/home" element={<Home />} />
        <Route path="/callback" element={<Callback />} />
        <Route path="/clear-session" element={null} />
        {routersConfig?.map((route) => (
          <Route key={route?.path} path={route?.path} element={
            <ProtectedRoute path={route?.path}>
              {route?.element}
            </ProtectedRoute>
          } />
        ))}
      </Routes>
    </main>
  </div>
  ) : (
<OfflineHandler />
  );
};

export default App;